import { Injectable } from '@angular/core';
import { PredicateFn } from '@fmnts/core';
import {
  ConditionDefinition,
  resolveConditionFn,
} from '@fmnts/declarative-forms';

/**
 * Service for building predicate functions from definitions
 */
@Injectable({
  providedIn: 'root',
})
export class PredicateNodeBuilder {
  /**
   * Creates a predicate function from a given condition definition
   *
   * @param def Definition for the condition
   *
   * @returns
   * Predicate function
   */
  public parseCondition<T>(
    def: ConditionDefinition | undefined,
  ): PredicateFn<T> {
    if (!def) {
      throw new Error('Cold not parse Condition for PredicateFn');
    }
    return resolveConditionFn(def);
  }
}
